/**
 * @file vdc检查结果
 * @author wangzhuang
 */

import {rcAjax, bAntiBotSend} from '../util';
import {GET_VDC_REPORT, GET_URL_UPLOAD} from './ActionTypes';

export function fetchVdcReport(dispatch, obj, type) {
    if (type === 'report') {
        bAntiBotSend();
        return new Promise(resolve => {
            window['__abbaidu_2024_cb'] = function (responseData) {
                let localData = JSON.parse(responseData);
                // task report
                if (localData.data) {
                    obj.data = localData.data;
                }
                if (localData.key_id) {
                    obj['key_id'] = localData.key_id;
                }
                if (localData.sign) {
                    obj.sign = localData.sign;
                }

                return rcAjax('POST', `/xiapi/api/v1/vdc/${type}`, {}, obj, data => {
                    const curData = data.data && data.data.data || {};
                    if (curData.is_auth === 'login') {
                        window.location.href = `/m/login/${location.href}`;
                        return;
                    }
                    dispatch({type: GET_VDC_REPORT, data: data.data});
                    resolve(data);
                });
            };
        });
    } else {
        const localKey = '__abbaidu_20181211_cb';
        let localData = {};
        try {
            if (window.localStorage) {
                localData = JSON.parse(window.localStorage.getItem(localKey)) || {};
            }
        }
        catch (e) {
            localData = {};
        }
        if (localData.data) {
            obj.data = localData.data;
        }
        if (localData.key_id) {
            obj['key_id'] = localData.key_id;
        }
        if (localData.sign) {
            obj.sign = localData.sign;
        }
        return rcAjax('POST', `/xiapi/api/v1/vdc/${type}`, {}, obj, data => {
            const curData = data.data && data.data.data || {};
            if (curData.is_auth === 'login') {
                window.location.href = `/m/login/${location.href}`;
                return;
            }
            dispatch({type: GET_VDC_REPORT, data: data.data});
        });
    }
}

export function fetchUrlUpload(dispatch, obj, type) {
    bAntiBotSend();
    return new Promise(resolve => {
        window['__abbaidu_2024_cb'] = function (responseData) {
            let localData = JSON.parse(responseData);
            // urlUpload  fileUpload
            if (localData.data) {
                obj.data = localData.data;
            }
            if (localData.key_id) {
                obj['key_id'] = localData.key_id;
            }
            if (localData.sign) {
                obj.sign = localData.sign;
            }

            let formData = new FormData();

            for (let attr in obj) {
                formData.append(attr, obj[attr]);
            }

            return rcAjax('POST', `/xiapi/api/v1/vdc/${type}`, {}, type === 'fileUpload' ? formData : obj, data => {
                const curData = data.data && data.data.data || {};
                if (curData.is_auth === 'login') {
                    window.location.href = `/m/login/${location.href}`;
                    return;
                }
                dispatch({type: GET_URL_UPLOAD, data: data.data});
                resolve(data);
            });
        };
    });
}



// WEBPACK FOOTER //
// ./src/actions/fileCheckAction.js